const content = document.querySelector('.article-content');
let contentHtml = content.innerHTML;

// 1) Clean des balises BLOCK
contentHtml = contentHtml
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*BLOCK(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[BLOCK]')
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*\/(?:&nbsp;|\s|<[^>\]]+>)*BLOCK(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[/BLOCK]')
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*BLOCK3(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[BLOCK3]')
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*\/(?:&nbsp;|\s|<[^>\]]+>)*BLOCK3(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[/BLOCK3]')
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*BLOCKR(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[BLOCKR]')
    .replace(/\[\s*(?:&nbsp;|\s|<[^>\]]+>)*\/(?:&nbsp;|\s|<[^>\]]+>)*BLOCKR(?:&nbsp;|\s|<[^>\]]+>)*\]/gi, '[/BLOCKR]');

contentHtml = contentHtml
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[BLOCK\]\s*(?:<\/span>\s*)?<\/p>/gi, '[BLOCK]')
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[\/BLOCK\]\s*(?:<\/span>\s*)?<\/p>/gi, '[/BLOCK]')
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[BLOCK3\]\s*(?:<\/span>\s*)?<\/p>/gi, '[BLOCK3]')
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[\/BLOCK3\]\s*(?:<\/span>\s*)?<\/p>/gi, '[/BLOCK3]')
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[BLOCKR\]\s*(?:<\/span>\s*)?<\/p>/gi, '[BLOCKR]')
    .replace(/<p[^>]*>\s*(?:<span[^>]*>\s*)?\[\/BLOCKR\]\s*(?:<\/span>\s*)?<\/p>/gi, '[/BLOCKR]');

contentHtml = contentHtml
    .replace(/\[BLOCK\]/gi, '<div class="article-row"><div class="text-wrapper">')
    .replace(/\[\/BLOCK\]/gi, '</div></div>')
    .replace(/\[BLOCK3\]/gi, '<div class="article-row3">')
    .replace(/\[\/BLOCK3\]/gi, '</div>')
    .replace(/\[BLOCKR\]/gi, '<div class="article-row-reverse">')
    .replace(/\[\/BLOCKR\]/gi, '</div>');

content.innerHTML = contentHtml;

const articleRows = content.querySelectorAll('.article-row');
articleRows.forEach((articleRow) => {
  const imgWrapper = document.createElement('div');
  imgWrapper.className = 'img-wrapper';

  const textWrapper = document.createElement('div');
  textWrapper.className = 'text-wrapper';

  // Récupération de l'image
  const img = articleRow.querySelector('img');
  imgWrapper.appendChild(img);
  articleRow.appendChild(imgWrapper);
});

const articleRowsReverse = content.querySelectorAll('.article-row-reverse');
articleRowsReverse.forEach((articleRowReverse) => {
  const img = articleRowReverse.querySelector('img');
  const imgWrapper = document.createElement('div');
  imgWrapper.className = 'img-wrapper';

  const textWrapper = document.createElement('div');
  textWrapper.className = 'text-wrapper';

  Array.from(articleRowReverse.childNodes).forEach(node => {
    if (node.nodeType === 1 && node.tagName.toLowerCase() === 'img') return;
    textWrapper.appendChild(node);
  });

  if (img) imgWrapper.appendChild(img);

  articleRowReverse.innerHTML = '';
  articleRowReverse.appendChild(imgWrapper);
  articleRowReverse.appendChild(textWrapper);
});

const emptyTags = content.querySelectorAll('.article-row p:empty, .article-row3 p:empty, .article-row-reverse p:empty');
emptyTags.forEach((emptyTag) => {
  emptyTag.remove();
})